<script>
    export default {
        /////////////////////////////////////////////////////
        // Data
        /////////////////////////////////////////////////////
        data() {
            return {}
        },
        /////////////////////////////////////////////////////
        // Props
        /////////////////////////////////////////////////////
        props: {
            'step': {
                type: Number,
                default: 0
            },
            'dataLoaded': {
                type: Boolean,
                default: false
            }
        },
        watch: {
            step: function (val) {
                switch (val) {
                    case 2:
                        $('html, body').animate({scrollTop: 1}, 'slow')
                        break
                }
            }
        },
        /////////////////////////////////////////////////////
        // Mounted
        /////////////////////////////////////////////////////
        mounted() {
            if (window.innerHeight < 800) {
                $('html, body').animate({scrollTop: 200}, 'slow')
            }
        },
        /////////////////////////////////////////////////////
        // Methods
        /////////////////////////////////////////////////////
        methods: {
            nextPage() {
                if (this.step == 2) {
                    window.location = '12.html'
                }
            },
            nextStep() {
                this.$emit('next', parseInt(this.step) + 1);
            },
            prevStep() {
                this.$emit('prev', parseInt(this.step) - 1);
            }
        }
    }

</script>



// WEBPACK FOOTER //
// _vue/components/Page-11.vue